<div>
  <app-dashboard-menu></app-dashboard-menu>
 
<div class="card">
<div class="PerformanceTrendModalBody">
<!-- <div class="dashboardContentBox"> -->
  
         <div class="col-sm-12 col-xs-12 col-md-6 col-lg-3">
                <label class="form-label">{{"ordersOverTimeReport"|translate}}</label>
                <input type="number" (keypress)="onlyNumbers($event)" class="form-control form-control-lg"  #totalMonthlyOrder 
                  placeholder="{{'enterToTalOrder' | translate}} *">
                <p class="alert alert-danger" *ngIf="showError">
                  {{'pleaseEnterTotalMonthlyOrder' | translate}}</p>
             
                  <button class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" type="submit" (click)="CreateChartSelectedDateWise(totalMonthlyOrder.value)">
      {{'Get' | translate}}
    </button>
            </div>
       
        <div class="col-sm-12 col-xs-12 col-md-5 col-lg-9" style="display: block">

          <canvas baseChart
                  [datasets]="lineChartData"
                  [labels]="lineChartLabels"
                  [options]="lineChartOptions"
                  [colors]="lineChartColors"          
                  [chartType]="lineChartType"
                  (chartHover)="chartHovered($event)"
                  (chartClick)="chartClicked($event)"></canvas>


        </div>
 <!-- </div> -->
  </div> 
</div>

</div>